/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild} from '@angular/core';

import {DatagridFilter} from '../../datagrid-filter';
import {StringFilter} from '../../interfaces/string-filter';
import {CustomFilter} from '../../providers/custom-filter';
import {FiltersProvider, RegisteredFilter} from '../../providers/filters';
import {DomAdapter} from '../../render/dom-adapter';
import {DatagridFilterRegistrar} from '../../utils/datagrid-filter-registrar';

import {DatagridStringFilterImpl} from './datagrid-string-filter-impl';
export class DatagridStringFilter extends DatagridFilterRegistrar<DatagridStringFilterImpl> implements CustomFilter,
                                                                                                       AfterViewInit {
/**
 * @param {?} renderer
 * @param {?} filters
 * @param {?} domAdapter
 */
constructor(private renderer: Renderer2, filters: FiltersProvider,
private domAdapter: DomAdapter) {
        super(filters);
    }
/**
 * Customizable filter logic based on a search text
 * @param {?} value
 * @return {?}
 */
set customStringFilter(value: StringFilter<any>|RegisteredFilter<DatagridStringFilterImpl>) {
        if (value instanceof RegisteredFilter) {
            this.setFilter(value);
        } else {
            this.setFilter(new DatagridStringFilterImpl( /** @type {?} */((<StringFilter<any>>value))));
        }
    }
/**
 * Indicates if the filter dropdown is open
 */
public open: boolean = false;
/**
 * We need the actual input element to automatically focus on it
 */
public input: ElementRef;
/**
 * We grab the DatagridFilter we wrap to register this StringFilter to it.
 */
public filterContainer: DatagridFilter;
/**
 * @return {?}
 */
ngAfterViewInit() {
        this.filterContainer.openChanged.subscribe((open: boolean) => {
            if (open) {
                // We need the timeout because at the time this executes, the input isn't
                // displayed yet.
                setTimeout(() => {
                    this.domAdapter.focus(this.input.nativeElement);
                });
            }
        });
    }
/**
 * Common setter for the input value
 * @return {?}
 */
public get value() {
        return this.filter.value;
    }
/**
 * @param {?} value
 * @return {?}
 */
public set value(value: string) {
        if (!this.filter) {
            return;
        }
        if (!value) {
            value = "";
        }
        if (value !== this.filter.value) {
            this.filter.value = value;
            this.filterValueChange.emit(value);
        }
    }

     filterValueChange = new EventEmitter();
/**
 * @return {?}
 */
public close() {
        this.open = false;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-dg-string-filter",
    providers: [{provide: CustomFilter, useExisting: DatagridStringFilter}],
    template: `
        <clr-dg-filter [clrDgFilter]="registered" [(clrDgFilterOpen)]="open">
            <!--
                Even though this *ngIf looks useless because the filter container already has one,
                it prevents NgControlStatus and other directives automatically added by Angular
                on inputs with NgModel from freaking out because of their host binding changing
                mid-change detection when the input is destroyed.
            -->
            <input #input type="text" name="search" [(ngModel)]="value" *ngIf="open"
                (keyup.enter)="close()" (keyup.escape)="close()"/>
        </clr-dg-filter>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: FiltersProvider, },
{type: DomAdapter, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'customStringFilter': [{ type: Input, args: ["clrDgStringFilter", ] },],
'input': [{ type: ViewChild, args: ["input", ] },],
'filterContainer': [{ type: ViewChild, args: [DatagridFilter, ] },],
'value': [{ type: Input, args: ["clrFilterValue", ] },],
'filterValueChange': [{ type: Output, args: ["clrFilterValueChange", ] },],
};
}

function DatagridStringFilter_tsickle_Closure_declarations() {
/** @type {?} */
DatagridStringFilter.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridStringFilter.ctorParameters;
/** @type {?} */
DatagridStringFilter.propDecorators;
/**
 * Indicates if the filter dropdown is open
 * @type {?}
 */
DatagridStringFilter.prototype.open;
/**
 * We need the actual input element to automatically focus on it
 * @type {?}
 */
DatagridStringFilter.prototype.input;
/**
 * We grab the DatagridFilter we wrap to register this StringFilter to it.
 * @type {?}
 */
DatagridStringFilter.prototype.filterContainer;
/** @type {?} */
DatagridStringFilter.prototype.filterValueChange;
/** @type {?} */
DatagridStringFilter.prototype.renderer;
/** @type {?} */
DatagridStringFilter.prototype.domAdapter;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
